import React from 'react'
import { DialogOverlay, DialogOverlayFooter, DialogOverlayActions, Button, Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { NoticeLoading } from '@fs/zion-icon'

export default function ViewTreeDetailsOverlay({ overlay, fileInfo }) {
  return (
    <DialogOverlay {...overlay} title={fileInfo?.title}>
      {fileInfo?.title ? (
        <ViewTreeDetailsOverlayContent fileInfo={fileInfo} />
      ) : (
        <Paragraph centered>
          <NoticeLoading size="lg" />
        </Paragraph>
      )}
    </DialogOverlay>
  )
}

function ViewTreeDetailsOverlayContent({ fileInfo }) {
  const [t] = useTranslation()
  return (
    <>
      <Paragraph size="sm">{t('group-management.gedcom-upload-complete.message')}</Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button
            emphasis="medium"
            external
            data-testid="gedcom-upload-view-personal-tree-button"
            to={`/groups/research-tree/${fileInfo?.groupId}`}
          >
            {t('group-management.view-researcher-view-named.action', { treeName: fileInfo?.title })}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </>
  )
}
